var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    [
      _c(
        "v-row",
        [
          _c(
            "v-col",
            {
              staticClass:
                "d-flex flex-wrap align-content-center justify-center"
            },
            _vm._l(_vm.items, function(file) {
              return _c(
                "v-card",
                {
                  key: file.name,
                  staticClass: "mx-auto mb-5 mx-2 file-card pull-up",
                  style:
                    "border-left: 5px solid " + file.color + " !important;",
                  attrs: { width: "250", "max-width": "300" },
                  on: {
                    click: function($event) {
                      return _vm.openFile(file.uriFormat)
                    }
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "pa-10 ma-2 d-flex justify-center card--image__background"
                    },
                    [
                      _c(
                        "v-icon",
                        {
                          attrs: {
                            "x-large": "",
                            color: "red",
                            heigth: "200px"
                          }
                        },
                        [_vm._v("mdi-adobe-acrobat")]
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-card-title",
                    { staticClass: "font-weight-light mt-0 pt-0" },
                    [_vm._v(" " + _vm._s(file.name) + " ")]
                  ),
                  _c("v-card-subtitle", { staticClass: "justify-left" }, [
                    _c("strong", [
                      _vm._v(
                        "factura-" +
                          _vm._s(file.name.toLowerCase().replace(" ", "-")) +
                          ".pdf"
                      )
                    ])
                  ])
                ],
                1
              )
            }),
            1
          )
        ],
        1
      ),
      _c(
        "v-snackbar",
        {
          attrs: { top: "", timeout: _vm.timeout, color: "error" },
          model: {
            value: _vm.snackbarError,
            callback: function($$v) {
              _vm.snackbarError = $$v
            },
            expression: "snackbarError"
          }
        },
        [
          _vm._v(
            " Ocurrió un error obteniendo el archivo, por favor intente de nuevo "
          ),
          _c(
            "v-btn",
            {
              attrs: { color: "white", text: "" },
              on: {
                click: function($event) {
                  _vm.snackbarError = false
                }
              }
            },
            [_vm._v("Cerrar")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }